import currencies from '../../../data/currencies.json';

export function getMaximumAlbumPrice(name) {
  const currency = getCurrency(name);
  return currency && currency.sl ? Number(currency.al) : Number.MAX_SAFE_INTEGER;
}

export function getMaximumTrackPrice(name) {
  const currency = getCurrency(name);
  return currency && currency.sl ? Number(currency.sl) : Number.MAX_SAFE_INTEGER;
}

function getCurrency(name) {
  return currencies[name];
}
